import { useMemo } from 'react';

import type { PasswordRequirementData } from '@quick/components/Forms/Password';

import { useAppTranslation } from '@/app/i18n/client';

export const usePasswordRequirements = (): PasswordRequirementData[] => {
  const { t } = useAppTranslation('common');
  return useMemo(
    () => [
      { label: t('passwordRequirements.length'), req: (p) => p.length >= 10 },
      {
        label: t('passwordRequirements.number'),
        req: /[0-9]/,
      },
      { label: t('passwordRequirements.capital'), req: /[A-Z]/ },
      { label: t('passwordRequirements.lower'), req: /[a-z]/ },
      { label: t('passwordRequirements.symbol'), req: /[\W]/ },
    ],
    [t]
  );
};
